import { render } from "./card-contacts.vue?vue&type=template&id=6b4e6183&scoped=true&ts=true"
import script from "./card-contacts.vue?vue&type=script&lang=ts"
export * from "./card-contacts.vue?vue&type=script&lang=ts"

import "./card-contacts.vue?vue&type=style&index=0&id=6b4e6183&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e6183"]])

export default __exports__